import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'CardLayout',
  description: '',
  categories: [],
  props: t.object({
    children: t.any()
  }),
  examples: {
    basic: {
      props: {
        children: <div>
          Children
        </div>
      },
      description: ''
    }
  },
  todo: [],
})
